import React from "react";



import {
  Box,
  Container,
  Divider,
  Grid,
  styled,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Footer = () => {


  const StyledLinks = styled(Link)(({ theme }) => ({
    color: "black",
    textDecoration: "none",
    transition: "0.5s ease-in-out",
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
  }));

  return (
      <footer>
        <Box
          sx={{
            color: "background.default",
            padding: "1rem",
          }}
        >
          <Container>
            {/* Logo Section */}
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
                width: "130",
                height: "100px",
              }}
            >
              <Link to="/">
              <img
                
                src="/ElektrotechnikEMN.png"
                alt="EMN Elektrotechnik - Elektroinstallation und Gebäudetechnik"
                style={{
                  width: "130px",
                  height: "100px",
                  objectFit:'contain'
                }}
              />
              </Link>
            </Box> */}
            <Grid container spacing={2}>
            <Grid item xs={12}
              sx={{
                marginBottom:'5vh'
              }}
            >
<Box
              sx={{
                marginTop: "1rem",
                borderRadius: "8px",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              }}
            >
             <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2542.529797018664!2d8.0617!3d50.4126!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bc32da39e10a8b%3A0xd977b8d30f7373e6!2sBrunnenstra%C3%9Fe%202A%2C%2065555%20Limburg%20an%20der%20Lahn%2C%20Germany!5e0!3m2!1sen!2seg!4v1737905964445!5m2!1sen!2seg"
  title="Karte zeigt den Standort von EMN Elektrotechnik in Limburg-Offheim, Deutschland"
  width="100%"
  height="200"
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  style={{ border: "0", borderRadius: "8px" }}
></iframe>

            </Box>
</Grid>
              <Grid xs={12} md={5}
            
              >
               
                <Typography
                  variant="body1"
                  sx={{
                    color: "black",
                    marginTop: ".9rem",
                  }}
                >
                   <span
                   style={{
                    color:'#fd0b0b'
                   }}
                   > EMN Elektrotechnik</span>  ist ein führendes Unternehmen im Bereich der Elektroinstallation und modernen Gebäudetechnik
                </Typography>
              </Grid>

              {/* Links */}
              <Grid
  xs={12}
  md={2}
  sx={{
    display: "flex",
    flexDirection: "column",
  }}
>
  <Typography
    variant="h6"
    sx={{
      color: '#fd0b0b',
    }}
  >
    Schnell Links
  </Typography>
  <Box
    component="ul"
    sx={{
      listStyleType: "none",
      padding: 0,
      transition: "color 0.5s ease-in-out",
    }}
  >
    <Typography component={"li"}>
      <StyledLinks to="/" onClick={() => { window.scrollTo(0, 0); }}>
        Startseite
      </StyledLinks>
    </Typography>
    <Typography component={"li"}>
      <StyledLinks to="/" onClick={() => {  window.location.hash = "#about"; }}>
        Über uns
      </StyledLinks>
    </Typography>
    <Typography component={"li"}>
      <StyledLinks to="/" onClick={() => {window.location.hash = "#services"; }}>
        Dienstleistungen
      </StyledLinks>
    </Typography>
    <Typography component={"li"}>
      <StyledLinks to="/appointment" onClick={() => { window.scrollTo(0, 0); }}>
        Termin buchen
      </StyledLinks>
    </Typography>
    <Typography component={"li"}>
      <StyledLinks to="/" onClick={() => { window.scrollTo(0, 0); window.location.hash = "#contact"; }}>
        Kontakt
      </StyledLinks>
    </Typography>
   
    
   
  </Box>
</Grid>


<Grid
  xs={12}
  md={5}
  sx={{
    display: "flex",
    flexDirection: "column",
  }}
>
  <Typography
    variant="h6"
    sx={{
      marginBottom: 2,
      color: '#fd0b0b',

    }}
  >
    Kontaktinformationen
  </Typography>

  {/* Working Hours */}
  <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
    <AccessTimeIcon sx={{       color: '#fd0b0b',
 marginRight: 1 }} />
    <Typography variant="body1" sx={{ color: "#424242" }}>
      <strong>Arbeitszeiten:</strong> Montag bis Freitag, 08:00 - 16:30 Uhr
    </Typography>
  </Box>

  {/* Phone Number */}
  <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
    <PhoneIcon sx={{       color: '#fd0b0b',
 marginRight: 1 }} />
    <Typography variant="body1" sx={{ color: "#424242" }}>
      <strong>Telefonnummer:</strong>{" "}
      <a
        href="tel:+4915901600845"
        style={{
          textDecoration: "none",
          fontWeight: "bold",
          color: '#fd0b0b',

        }}
      >
        +49 1590 1600845
      </a>
    </Typography>
  </Box>

  {/* Address */}
  <Box sx={{ display: "flex", alignItems: "center" }}>
    <LocationOnIcon sx={{      color: '#fd0b0b',
 marginRight: 1 }} />
    <Typography variant="body1" sx={{ color: "#424242" }}>
      <strong>Adresse:</strong> Deutschland, Schulstraße 48
65594 Runkel-Steeden
    </Typography>
  </Box>
</Grid>;
{/* <Grid item xs={12}>
<Box
              sx={{
                marginTop: "1rem",
                borderRadius: "8px",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              }}
            >
             <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2542.529797018664!2d8.0617!3d50.4126!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bc32da39e10a8b%3A0xd977b8d30f7373e6!2sBrunnenstra%C3%9Fe%202A%2C%2065555%20Limburg%20an%20der%20Lahn%2C%20Germany!5e0!3m2!1sen!2seg!4v1737905964445!5m2!1sen!2seg"
  title="Karte zeigt den Standort von EMN Elektrotechnik in Limburg-Offheim, Deutschland"
  width="100%"
  height="200"
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  style={{ border: "0", borderRadius: "8px" }}
></iframe>

            </Box>
</Grid> */}



             
            </Grid>
            <Divider sx={{ marginTop: "1.5rem", borderColor: "black" }} />

           
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
                alignItems: "center",
                marginBottom: "1rem",
                gap: "1rem",
              }}
            >
              <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                color: "black",
              }}
            >
              &copy; {new Date().getFullYear()} <span
                   style={{
                    color:'red'
                   }}
                   > EMN Elektrotechnik</span>   All rights reserved  
            </Typography>
           
      </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
                alignItems: "center",
                marginBottom: "1rem",
                gap: "1rem",
              }}
            >
             
            <StyledLinks to="/impressum" onClick={() => { window.scrollTo(0, 0);}}>
              Impressum
      </StyledLinks>
      <StyledLinks to="/datenschutz" onClick={() => { window.scrollTo(0, 0);  }}>
      Datenschutz
      </StyledLinks>
      </Box>
            <Box
    sx={{
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <Typography variant="caption" sx={{
        color: "black",

    }}>
        Entwickelt und gestaltet von

      {/* <a
        href="https://bio.link/mahmoudalitech01"
        style={{
          color: "black",
          textDecoration: "none",
          transition: "0.5s ease-in-out",
          cursor: "pointer",
        }}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Typography
          variant="caption"
          sx={{
            color: "black",
            cursor: "pointer",
            "&:hover": {
              color: "#fd0b0b",
              textDecoration: "underline",
            },
            display: "inline",
          }}
        >
         {' '} M
        </Typography>
      </a>
      <Typography
        variant="caption"
        sx={{ margin: "0 1px", display: "inline" }}
      >
        &
      </Typography> */}
      {' '}
      <a
        href="https://shimaamohamed.bio.link/"
        style={{
          color: "black",
          textDecoration: "none",
          transition: "0.5s ease-in-out",
          cursor: "pointer",
        }}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Typography
          variant="caption"
          sx={{
            color: "black",
            cursor: "pointer",
            "&:hover": {
              color: "#fd0b0b",
              textDecoration: "underline",
            },
            display: "inline",
          }}
        >
          SoftMasters
        </Typography>
      </a>
    </Typography>
  </Box>


            
          </Container>
        </Box>
      </footer>
  );
};

export default Footer;
